module.exports = __webpack_public_path__ + "static/bg-autoagent-b7fd22301bff097a4ddeace83f219624.webp";